export const NAV_RAIL_WIDTH = 50;
export const NAV_RAIL_EXPANDED_WIDTH = 200;
/** Shared height for app header, gate tabs bar, and breadcrumb row. */
export const APP_HEADER_HEIGHT = 50;
/** Horizontal inset for profile header — gate tabs & breadcrumb align to match. */
export const INTAKE_PROFILE_ROW_PX = { xs: 1.5, md: 2.5 };
/** Gutters of the GATE-0..4 tabs bar. */
export const GATE_TABS_BAR_PL = { xs: 0.5, md: 1 };
export const GATE_TABS_BAR_PR = { xs: 2, md: 2.5 };
/**
 * Left gutter for the Test Strategies / Test Cases / Test Suite row.
 * Lands the first tab icon on the GATE-0 label. Each sub-tab hugs its
 * icon + label (no side padding) so the active underline matches Figma,
 * so the gutter and gap below carry the full spacing.
 */
export const GATE_SUBTABS_PL = { xs: "18px", md: "26px" };
/** Right gutter of the sub-tabs row — unchanged from the original px inset. */
export const GATE_SUBTABS_PR = { xs: 2, md: 3 };
/** Spacing between hugging sub-tabs — preserves the previous visual gap. */
export const GATE_SUBTABS_GAP = { xs: "32px", md: "48px" };
